export default [
  {
    path: '/users/managers',
    name: 'manager-list',
    component: () => import('@/views/users/managers/Index.vue'),
    meta: {
      pageTitle: 'Liste des managers',
      pageDesc: 'Consultez, filtrez et gérez les managers de votre organisation logistique. Utilisez les filtres avancés pour affiner la recherche.',
      breadcrumb: [
        {
          text: 'Managers',
          active: true,
          ariaLabel: 'Page active : liste des managers',
        },
      ],
      breadcrumbLabel: 'Liste des managers',
      resource: 'Auth',
      requireLogin: true,
      roles: ['admin', 'superadmin'],
      admin: true,
    },
  },
  {
    path: '/users/managers/add',
    name: 'manager-add',
    component: () => import('@/views/users/managers/Create.vue'),
    meta: {
      pageTitle: 'Ajouter un manager',
      pageDesc: 'Ajoutez un nouveau manager à votre organisation logistique. Remplissez tous les champs obligatoires et validez.',
      breadcrumb: [
        {
          text: 'Managers',
          to: { name: 'manager-list' },
          ariaLabel: 'Retour à la liste des managers',
        },
        {
          text: 'Ajouter',
          active: true,
          ariaLabel: 'Page active : ajout d\'un manager',
        },
      ],
      breadcrumbLabel: 'Ajouter un manager',
      resource: 'Auth',
      roles: ['admin', 'superadmin'],
      admin: true,
    },
  },
  {
    path: '/users/managers/edit/:id',
    name: 'manager-edit',
    component: () => import('@/views/users/managers/Edit.vue'),
    meta: {
      pageTitle: 'Modifier un manager',
      pageDesc: 'Modifiez les informations d\'un manager existant pour garantir la cohérence organisationnelle.',
      breadcrumb: [
        {
          text: 'Managers',
          to: { name: 'manager-list' },
          ariaLabel: 'Retour à la liste des managers',
        },
        {
          text: 'Modifier',
          active: true,
          ariaLabel: 'Page active : modification d\'un manager',
        },
      ],
      breadcrumbLabel: 'Modifier un manager',
      resource: 'Auth',
      roles: ['admin', 'superadmin'],
      admin: true,
    },
  },
  {
    path: '/users/managers/show/:id',
    name: 'manager-show',
    component: () => import('@/views/users/managers/Show.vue'),
    meta: {
      pageTitle: 'Détails du manager',
      pageDesc: 'Consultez les informations détaillées d\'un manager de l\'organisation.',
      breadcrumb: [
        {
          text: 'Managers',
          to: { name: 'manager-list' },
          ariaLabel: 'Retour à la liste des managers',
        },
        {
          text: 'Détails',
          active: true,
          ariaLabel: 'Page active : détails du manager',
        },
      ],
      breadcrumbLabel: 'Détails du manager',
      resource: 'Auth',
      roles: ['admin', 'superadmin'],
      admin: true,
    },
  },
  {
    path: '/managers/:id/change-password',
    name: 'manager-change-password',
    component: () => import('@/views/users/managers/ChangePassword.vue'),
    meta: {
      pageTitle: 'Changer le mot de passe',
      pageDesc: 'Modifiez le mot de passe d\'un manager pour garantir la sécurité des accès organisationnels.',
      breadcrumb: [
        {
          text: 'Accueil',
          to: '/',
          ariaLabel: 'Retour à l\'accueil',
        },
        {
          text: 'Managers',
          to: { name: 'manager-list' },
          ariaLabel: 'Retour à la liste des managers',
        },
        {
          text: 'Détail manager',
          to: { name: 'manager-show', params: { id: null } },
          paramId: 'id',
          ariaLabel: 'Retour au détail du manager',
        },
        {
          text: 'Changer le mot de passe',
          active: true,
          ariaLabel: 'Page active : changement du mot de passe du manager',
        },
      ],
      breadcrumbLabel: 'Changer le mot de passe',
      roles: ['admin', 'superadmin'],
      admin: true,
    },
  },
]
